const watch = {
  tableProperties(newValue) {
    const { tableColumns, data } = newValue;
    this.tableData = data;
    this.searchFuse(
      tableColumns.map((column) => {
        return column.prop;
      })
    );

    try {
      sessionStorage.setItem('tableCode', JSON.stringify(this.tableData));
    } catch (error) { }
  },
  refreshDetail(refreshDetail) {
    if (refreshDetail) {
      this.modifyTable(1, refreshDetail.data.data.id, refreshDetail)
    }
  }
};

export default watch;
